module.exports = __webpack_public_path__ + "assets/img/more-btn-2b980719.png";